import { Fade, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

function Actions({ competition, joinCompetition }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  //   const navigate = useNavigate();

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleCompetitionJoin = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    joinCompetition(competition);
  };

  return (
    <>
      <IconButton
        sx={{
          p: 0,
          "& .MuiSvgIcon-root": {
            color: "rgba(0, 0, 0, 0.87)",
          },
        }}
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleCompetitionJoin} key="end">
          <ListItemIcon>
            <InsertLinkIcon />
          </ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
            Join Competition
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}

export default Actions;
